// 导入了 vue
import Vue from 'vue';
// 导入了 VueROuter
import VueRouter from 'vue-router';
// 导入组件
import Layout from '../views/Layout';
import HomePage from '../views/HomePage';
import Menu from '../views/Menu';
import GameGuide from '../views/GameGuide';
import Rules from '../views/Rules';
import MyWorks from '../views/MyWorks';
import Entry from '../views/Entry';
import AwardWorks from '../views/AwardWorks';
// import MySchool from '../views/MySchool';
import WorkDetail from '../views/WorkDetail';

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: '/',
      component: Layout,
      // 设置子路由
      children: [
        { path: '/', component: HomePage },
        { path: 'rules', component: Rules },
        { path: 'guide', component: GameGuide },
        { path: 'works/1', component: MyWorks },
        { path: 'works/2', component: MyWorks },
        { path: 'show', component: Entry },
        { path: 'previous', component: AwardWorks },
        // { path: 'map', component: MySchool },
        { path: 'details/:typeId/:id', component: WorkDetail }
      ]
    },
    {
      path: '/Menu',
      component: Menu
    }
  ]
});
